import { render, staticRenderFns } from "./CreateCustomer.vue?vue&type=template&id=4495f1c8&scoped=true&v-if=this.%24store.getters.isLoggedIn&"
import script from "./CreateCustomer.vue?vue&type=script&lang=ts&"
export * from "./CreateCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4495f1c8",
  null
  
)

export default component.exports